import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { Notification } from '../../../../../services/NotificationService';
import { NotificationItem } from './NotificationItem';
import { TabPanel } from './TabPanel';

interface NotificationListProps {
  notifications: Notification[];
  unreadNotifications: Notification[];
  tabValue: number;
  isRead: (id: string) => boolean;
  onMarkAsRead: (id: string) => void;
  onArchive: (id: string) => void;
  onOpenDialog: (queryId: string, workspace?: string) => void;
}

export function NotificationList({
  notifications,
  unreadNotifications,
  tabValue,
  isRead,
  onMarkAsRead,
  onArchive,
  onOpenDialog,
}: NotificationListProps) {
  const sortedAll = useMemo(
    () =>
      [...notifications].sort((a, b) => {
        const aR = isRead(a.id), bR = isRead(b.id);
        if (aR !== bR) return aR ? 1 : -1;
        return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
      }),
    [notifications, isRead],
  );

  const renderItem = (n: Notification) => (
    <NotificationItem
      key={n.id}
      notification={n}
      read={isRead(n.id)}
      onMarkAsRead={onMarkAsRead}
      onArchive={onArchive}
      onOpenDialog={onOpenDialog}
    />
  );

  return (
    <Box sx={{ maxHeight: '45vh', overflow: 'auto', p: 1.25 }}>
      <TabPanel value={tabValue} index={0}>
        {unreadNotifications.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
            Aucune nouvelle notification
          </Typography>
        ) : (
          unreadNotifications.map(renderItem)
        )}
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        {notifications.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
            Aucune notification
          </Typography>
        ) : (
          sortedAll.map(renderItem)
        )}
      </TabPanel>
    </Box>
  );
}
